// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import router from './router'
import session from './utils/Session'
import EnvUtils from './utils/EnvUtils'
import configService from './service/config/ConfigService'
import appErrorService from './service/cloud/AppErrorService'
import Tool from "./utils/Tools";
import VueLazyload from 'vue-lazyload'

window.console = window.console || function () {};
//系统错误捕获
const errorHandler = (error, vm, info)=>{
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);
  session.isLogin().then(flag => {
    if(flag) {
      appErrorService.save(error.message, error.stack)
    }
  })
}

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);
Vue.prototype.$verfyBrowserType = function () {
  return true;
}

Vue.use(MintUI);
Vue.use(VueLazyload , { listenEvents: [ 'scroll' ]})
Vue.config.productionTip = false;
Vue.prototype.global = {};

const { token }= GetRequest();
if(!!token){
  session.loginLight({token});
}

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")

let url = window.location.href.split('#')[0];
configService.getPayConfig(url);


//登录验证拦截
router.beforeEach((to, from, next) => {
  let authBindPhone = to.meta.authBindPhone || false;
  if (authBindPhone) {
    session.isLogin().then(flag => {
      let backUrl = to.fullPath;
      if(flag){
        next();
      }else if(Tool.verfyBrowserType()){
        if(EnvUtils.inLight()){
          wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          return;
        } else if(!session.getOpenId()){
          session.backUrl(backUrl);
          next('/login')
        }else if(session.getOpenId()){
          session.userType('1');
          session.backUrl(backUrl);
          next('/bind/phone')
        }
      }else {
        session.backUrl(backUrl);
        next('/login')
      }
    })
  } else {
    next();
  }
});


//格式化时间 yyyy-mm-dd
Vue.filter('shortTime', function (value) {//value为13位的时间戳
  function add0(m) {
    return m < 10 ? '0' + m : m
  }
  var time = new Date(parseInt(value));
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();

  return y + '-' + add0(m) + '-' + add0(d)+" "+ add0(h) + ":" + add0(mm);
});


//工地实拍类型转换
Vue.filter('projectImageTypeConvert', function (value) {
  let imageType;
  if(value == '1'){
    imageType = '开工'
  }else if(value == '2'){
    imageType = '拆除'
  }else if(value == '3'){
    imageType = '水电'
  }else if(value == '4'){
    imageType = '瓦工'
  }else if(value == '5'){
    imageType = '木工'
  }else if(value == '6'){
    imageType = '油工'
  }else if(value == '7'){
    imageType = '竣工'
  }
  return imageType;
});

//监理服务类型转换
Vue.filter('serviceTypeConvert', function (value) {
  let serviceType;
  if(value == '1'){
    serviceType = '标准监理服务'
  }else if(value == '2'){
    serviceType = '全程监理服务'
  }else if(value == '3'){
    serviceType = '凯哥看报价服务'
  }
  return serviceType;
});

//服务人员评分保留1位小数
Vue.filter('serviceScoreConvert', function (value) {
  return value.toFixed(1);
});

//监理服务类型转换
Vue.filter('qaStatusConvert', function (value) {
    let qaStatus;
    if(value == '1'){
        qaStatus = '已发布'
    }else if(value == '2'){
        qaStatus = '待审核'
    }else if(value == '3'){
        qaStatus = '审核未通过'
    }
    return qaStatus;
});

//预约类型转换
Vue.filter('appointmentTypeConvert', function (value) {
  let appointmentType;
  if(value == '1'){
    appointmentType = '监理'
  }else if(value == '2'){
    appointmentType = '工长'
  }else if(value == '3'){
    appointmentType = '保洁'
  }else if(value == '4'){
    appointmentType = '搬家'
  }else if(value == '5'){
    appointmentType = '整包'
  }else if(value == '6'){
    appointmentType = '设计师'
  }else if(value == '8'){
    appointmentType = '打孔'
  }
  return appointmentType;
});

//图片裁剪处理
Vue.filter('ossProcess', function (value, width, height) {
  return `${value}?x-oss-process=image/crop,h_${height},w_${width},g_center`
});

//工地实拍类型转换
Vue.filter('projectNameConvert', function (value) {
  let projectName;
  if(value && value.length>10){
    projectName = value.substr(0,10) + '...';
  }else {
    projectName = value;
  }
  return projectName;
});

//项目类型转换
Vue.filter('projectTypeConvert', function (value) {
  let projectType;
  if(value == '1'){
    projectType = '监理'
  }else if(value == '2'){
    projectType = '工长'
  }else if(value == '5'){
    projectType = '整包'
  }else if(value == '6'){
    projectType = '设计师'
  }
  return projectType;
});

function GetRequest(data) {
  let url = window.location.href.split('#')[1] || '';
  let searchString = url.indexOf('?') > -1 ? url.substr(url.indexOf('?') + 1): '';
  console.log('GetRequest==='+ searchString)
  var theRequest = {};
  var searchKeyValues = searchString.split("&");
  for(var i = 0; i < searchKeyValues.length; i ++) {
    let keyValue = searchKeyValues[i];
    theRequest[keyValue.split("=")[0]]=decodeURIComponent(keyValue.split("=")[1]);
  }
  return theRequest;
}

/**
 * 获取时间格式 ： yyyy-MM-dd hh:mm:ss
 */
Vue.filter('time', function (value) { // value为13位的时间戳
  Date.prototype.format = function(format) {
    var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };
  var newDate = new Date();
  newDate.setTime(value);
  return newDate.format('yyyy-MM-dd')
});
Vue.filter('simpleDayFilter', function (value) {
  if (!value){
    return '';
  }
  function add0(m) {
    return m < 10 ? '0' + m : m
  }
  var time = new Date(parseInt(value));
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var ss = time.getSeconds();

  return y + '-' + add0(m) + '-' + add0(d);
})
//格式化时间 yyyy-mm-dd hh:MM:ss
Vue.filter('longTime', function (value) {//value为13位的时间戳
  if (!value){
    return '';
  }
  function add0(m) {
    return m < 10 ? '0' + m : m
  }
  var time = new Date(parseInt(value));
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var ss = time.getSeconds();

  return y + '-' + add0(m) + '-' + add0(d)+" "+ add0(h) + ":" + add0(mm) + ":" + add0(ss);
});

Vue.filter('constructionBgImage', function (index) {
  index = Number(index) + Number(1);
  let image = require('./assets/icon/icon-const-norm-bg-'+index+'.png');
  return image;
})

Vue.filter('shopLevelImage', function (level) {
  let image
  if(level == 1){
    image = require('./assets/icon/icon-level-bronze.png');
  }else if(level == 2){
    image = require('./assets/icon/icon-level-silver.png');
  }else if(level == 3){
    image = require('./assets/icon/icon-level-gold.png');
  }
  return image;
})

/**
* 时间美化 ：X小时前
*/
Vue.filter('prettifyTime', function (value, format) { // value为13位的时间戳
  if (!format) {
    format = 'yyyy.MM.dd hh:mm'
  }
  return goodTime(value);
  function goodTime(str){
    var now = new Date().getTime(),
      oldTime = new Date(str).getTime(),
      difference = now - oldTime,
      result='',
      minute = 1000 * 60,
      hour = minute * 60,
      day = hour * 24,
      halfamonth = day * 15,
      month = day * 30,
      year = month * 12,

      _year = difference/year,
      _month =difference/month,
      _week =difference/(7*day),
      _day =difference/day,
      _hour =difference/hour,
      _min =difference/minute;
    if(_year>=1) {result= ~~(_year) + "年前"}
    else if(_month>=1) {result= ~~(_month) + "个月前"}
    else if(_week>=1) {result= ~~(_week) + "周前"}
    else if(_day>=1) {result= ~~(_day) +"天前"}
    else if(_hour>=1) {result= ~~(_hour) +"个小时前"}
    else if(_min>=1) {result= ~~(_min) +"分钟前"}
    else result="刚刚";
    return result;
  }
})

//格式化评分
Vue.filter('score', function (value) { // value为13位的时间戳
  if(value > 0){
    return value.toFixed(1);
  }
})
Vue.filter('fscore', function (value) { // value为13位的时间戳
  if(value > 0){
    return value.toFixed(1);
  }
})
//格式化天数
Vue.filter('formatterDays', function (value) {
  if (!value){
    return 0;
  }
  let time = parseInt(`${value}`)
  if(isNaN(time)){
    return 0;
  }
  return Math.ceil(time / (1000 * 60 * 60 * 24)).toFixed(0)
})
